import { Pipe, PipeTransform, inject } from "@angular/core"
import { DomSanitizer, SafeHtml } from "@angular/platform-browser"
import { marked } from "marked"

@Pipe({ name: "markdown" })
export class MarkdownPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer)

  transform(value: string): SafeHtml {
    if (!value) return ""
    const html = marked.parse(value) as string
    return this.sanitizer.bypassSecurityTrustHtml(html)
  }
}
